import * as React from 'react';

import LearnerStatsCard from 'bundles/campaigns/components/LearnerStatsCard';
import { useCampaignModulesData } from 'bundles/campaigns/context/CampaignModulesDataContext';

const CampaignLearnerStatsModuleRenderer = () => {
  const moduleData = useCampaignModulesData()?.campaignData?.learnerStatsModule;

  if (!moduleData?.contentDataJson) {
    return null;
  }

  const { headlineStat, bodyText, ctaLabel, ctaUrl, icon } = moduleData.contentDataJson;

  return (
    <LearnerStatsCard
      bodyText={bodyText}
      ctaLabel={ctaLabel}
      ctaUrl={ctaUrl}
      headlineStat={headlineStat}
      cdsIconName={icon}
    />
  );
};

export default CampaignLearnerStatsModuleRenderer;
